import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";

const WEEKDAYS_DE = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
const MONTHS_DE = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];

/**
 * Digital clock + date pill for the header bar.
 * - Updates every second
 * - Format: weekday short DD.MM.YYYY · HH:MM:SS
 * - Locale: Swiss-German (de-CH)
 * - Premium look: subtle border, gold accent on time digits, mono font for digits
 */
export default function HeaderClock() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const pad = (n) => String(n).padStart(2, "0");
  const h = pad(now.getHours());
  const m = pad(now.getMinutes());
  const s = pad(now.getSeconds());
  const weekday = WEEKDAYS_DE[now.getDay()];
  const day = pad(now.getDate());
  const month = MONTHS_DE[now.getMonth()];
  const year = now.getFullYear();

  return (
    <div
      className="hidden md:inline-flex items-center gap-3 px-3.5 py-1.5 rounded-md border border-border bg-card/60 hover:bg-card transition-colors"
      data-testid="header-clock"
      title="Aktuelle Uhrzeit Schweiz"
    >
      <Clock className="w-3.5 h-3.5 text-prime shrink-0" strokeWidth={1.7} />
      <div className="flex items-center gap-2.5">
        <div className="flex flex-col leading-tight">
          <span className="text-[9px] uppercase tracking-widest text-muted-foreground font-bold">{weekday}</span>
          <span className="text-[11px] font-medium text-foreground/80">{day}. {month} {year}</span>
        </div>
        <div className="h-7 w-px bg-border" />
        <div
          className="font-mono font-bold text-base tracking-tight text-foreground"
          data-testid="header-clock-time"
        >
          <span>{h}</span>
          <span className="text-prime mx-px animate-pulse">:</span>
          <span>{m}</span>
          <span className="text-prime mx-px animate-pulse">:</span>
          <span className="text-muted-foreground">{s}</span>
        </div>
      </div>
    </div>
  );
}
